import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales/overviews'

export default {
  namespaced: true,
  state: {
    loading: false,
    overviews: {
      sales: 0,
      connections: 0,
      goals: 0,
      stocks: 0,
      swaps: 0,
      interviews: 0,
      customers: 0,
      charts: {
        series: [],
        categories: [],
        chartTitle: null,
        yaxis: [],
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    overviews(state) {
      return state.overviews
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_OVERVIEWS(state, data) {
      state.overviews = data
    },
    /* RESET MUTATIONS */
    RESET_OVERVIEWS(state) {
      state.overviews = {
        sales: 0,
        connections: 0,
        goals: 0,
        stocks: 0,
        swaps: 0,
        interviews: 0,
        customers: 0,
        charts: {
          series: [],
          categories: [],
          chartTitle: null,
          yaxis: [],
        },
      }
    },
  },
  actions: {
    getOverviews({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_OVERVIEWS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_OVERVIEWS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
